var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "doctype-modal",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
      _c(
        "c-sidesheet",
        {
          attrs: { active: _vm.active, title: _vm.sidesheetHeader },
          on: { close: _vm.close },
          scopedSlots: _vm._u(
            [
              _vm.displayActions
                ? {
                    key: "actions",
                    fn: function () {
                      return [_vm._t("sidesheet-actions")]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _c("div", { staticClass: "doctype-form" }, [
            _c("div", { staticClass: "doctype-form" }, [_vm._t("default")], 2),
            _c(
              "div",
              { staticClass: "doctype-form__actions" },
              [
                _c("c-button-2", {
                  staticClass: "doctype-form__reset",
                  attrs: { size: "large", label: "Отменить" },
                  on: { click: _vm.reset },
                }),
                _c("c-button-2", {
                  staticClass: "doctype-form__save",
                  attrs: {
                    label: "Сохранить",
                    color: "primary",
                    size: "large",
                    disabled: _vm.pending,
                  },
                  on: { click: _vm.submit },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }